
import * as React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { ICommission } from '../../../../data/entities/commission';
import { ICommissionChannels } from '../../../../data/entities/commission-channels';
import { customerIsLegacyCommission } from '../../../../data/entities/commission/selectors';
import { IProperty } from '../../../../data/entities/property';
import { actions } from '../../../../data/store';
import { useDataLoad } from '../../../helpers/hooks';

import { currentUserId } from '../../../../entities/auth/session/selectors';
import { IChannel } from '../../../../entities/contracts/types';
import { IPolicies } from '../../../../entities/policies/types';
import { IThunkDispatch } from '../../../../store/middleware';
import { IState } from '../../../../store/reducer';
import { getMarketingPreferences } from '../actions';
import { IMarketingPreferences } from '../home/types';
import { MarketingChannelComponent } from './MarketingChannel';

interface IMarketingChannelContainerProps {
	channel: string;
	channels: IChannel[];
	properties: IProperty[];
	customerId: string;
	policies: IPolicies;
	marketingPreferences: IMarketingPreferences;
	commissions: ICommission;
	commissionChannels: ICommissionChannels;
	isLegacyCommission: boolean;
	getMarketingPreferences(customerId: string): Promise<any>;
	getCustomerCommissions(customerId: string): any;
	getCustomerCommissionChannels(customerId: string): any;
}

const mapDispatchToProps = (dispatch: IThunkDispatch) => ({
	getMarketingPreferences: (customerId: string) => dispatch(getMarketingPreferences(customerId)),
	getCustomerCommissions: (customerId: string) => dispatch(actions.commission.getByCustomer(customerId)),
	getCustomerCommissionChannels: (customerId: string) => dispatch(actions.commissionChannels.getByCustomer(customerId))
});

const mapStateToProps = () => (state: IState) => {
	const customerId = currentUserId(state);
	return {
		marketingPreferences: state.views.marketing.home.drafts[customerId] || {},
		channels: state.entities.channels.defaultChannels,
		properties: state.data.properties.byId,
		policies: state.entities.policies.policyData,
		commissions: state.data.commission.byCustomer[customerId],
		commissionChannels: state.data.commissionChannels.byCustomer[customerId],
		isLegacyCommission: customerIsLegacyCommission(state, customerId),
		customerId
	};
};

const MarketingChannelContainer: React.FC<Omit<IMarketingChannelContainerProps, 'channel'>> = (props) => {
	const { channels, properties, policies, commissions, commissionChannels, isLegacyCommission } = props;
	const { contracts, cancellationPolicy } = props.marketingPreferences;

	const loading = useDataLoad(!contracts || !cancellationPolicy, () => props.getMarketingPreferences(props.customerId));
	useDataLoad(!props.commissions, () => props.getCustomerCommissions(props.customerId));
	useDataLoad(!props.commissionChannels, () => props.getCustomerCommissionChannels(props.customerId));

	const params = useParams();
	const channel = params.channel || '';

	return <MarketingChannelComponent
		loading={loading}
		channel={channel}
		properties={properties}
		policy={props.marketingPreferences.cancellationPolicy}
		channels={channels}
		policies={policies}
		commissions={commissions}
		commissionChannels={commissionChannels}
		isLegacyCommission={isLegacyCommission}
	/>;
};

export const MarketingChannel = connect(mapStateToProps, mapDispatchToProps)(MarketingChannelContainer);
